export const FEATURES = {
  REGISTER: 'register',
  PAYMENT: 'payment',
  AUTO_PAYMENT: 'auto_payment',
  DASHBOARD: 'dashboard',
  POSTHOG: 'posthog',
}
